import { useState, useEffect } from "react";

const defaultSeo = {
  title: "ProCoor",
  description:
    "ProCoor is a complete construction management system specially designed by engineering and construction professionals for the construction industry.",
};

export function useSeo({ pageName }) {
  const [seo, setSeo] = useState(defaultSeo);

  useEffect(() => {
    const fetchSeoData = async () => {
      if (pageName) {
        try {
          const response = await fetch("/assets/Seo.json");
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          setSeo(data[pageName] || defaultSeo);
        } catch (error) {
          console.error("Error loading SEO data:", error);
          setSeo(defaultSeo);
        }
      }
    };

    fetchSeoData();
  }, [pageName]);

  return seo;
}

export function useCertification() {
  const [data, setData] = useState("");

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await fetch("/assets/certificationData.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setData(data);
      } catch (error) {
        console.error("Error loading Certification data:", error);
      }
    };

    fetchSeoData();
  }, []);

  return data;
}
export function useDropdownData() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await fetch("/assets/companyType.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setData(data);
      } catch (error) {
        console.error("Error loading CompanyType data:", error);
      }
    };

    fetchSeoData();
  }, []);

  return data;
}
